// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from "@mui/material";
import { Button } from "../atoms";
import {
    useCreateMerchantHash, useGetHashMerchant,
  } from "../../hooks";
  import { useSetSnackBar } from "../../store/Snackbar.state";

interface Props {
  merchantId: string; 
  getHashPasswordOpen: boolean;
  setGetHashPasswordOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

 export const GetHashPasswordDialog: React.FC<Props> = ({ merchantId, getHashPasswordOpen, setGetHashPasswordOpen, setShouldRefresh }) => {
    const setSnackbar = useSetSnackBar();
    const { mutate: getMerchantHash, isLoading } = useGetHashMerchant();
    const handleSend = () => {
        getMerchantHash(
          { merchantId: merchantId },
          {
            onSuccess: (data) => {
              if (data.isSuccess) {
                setSnackbar({
                  severity: 'success',
                  description: data.message || 'İşlem başarılı.',
                  isOpen: true,
                });
                setShouldRefresh(prev => !prev);
              } else {
                setSnackbar({
                  severity: 'error',
                  description: data.message,
                  isOpen: true,
                });
              }
            },
            onError: (error) => {
              setSnackbar({
                severity: 'error',
                description: error.message || 'İşlem sırasında bir hata oluştu.',
                isOpen: true,
              });
            }
          }
        );
        setGetHashPasswordOpen(false);
      };
    
      return (
        <>
          <Dialog open={getHashPasswordOpen} onClose={() => setGetHashPasswordOpen(false)}>
         
            <DialogContent>
              <DialogContentText>
              Mevcut Üye İşyeri Şifresini Göndermek İstiyor Musunuz?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleSend} color="primary" text='Evet'  variant="contained"   disabled={isLoading}>
                Evet
              </Button>
              <Button onClick={() => setGetHashPasswordOpen(false)} text='Hayır'  color="primary" variant="outlined" >
                Hayır
              </Button>
          
            </DialogActions>
          </Dialog>
        </>
      );
};


